import { BehaviorSubject, Observable} from 'rxjs';
//import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { throwError, TimeoutError } from 'rxjs';

import { timeout, catchError, map, retry, first} from 'rxjs/operators';
import { Injectable }     from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { Router }         from '@angular/router';
//import { first , retry}          from 'rxjs/operators';
//import { JwtHelper }      from 'angular2-jwt';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Credentials, UserOrg , Scope, Ops, Referral }    from '../../_models/index';
import { environment }       from '../../../environments/environment';
//import { Http, Response, 
        //Headers, RequestOptions }   from '@angular/http';
import * as CryptoJS      from 'crypto-js';
//import { NgFlashService } from 'ng-flash';
//import { AngularFireAuth } from '@angular/fire/auth';
//import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { inject }     from '@angular/core';

//import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
//import { provideFirestore, getFirestore } from '@angular/fire/firestore';
//import { provideAuth, getAuth } from '@angular/fire/auth';
//import { Auth } from '@angular/fire/auth';
//import { signInWithCustomToken } from '@angular/fire/auth';

import { AngularFirestore }    from '@angular/fire/compat/firestore';
import { AngularFireAuth }     from '@angular/fire/compat/auth';

import { FS_REFRESHSTATUS, Refreshpagestatus, Referraltype }                       from '../../_models/index';
import { MAINREFREFERENCEMASTER_REFID }         from '../../_models/constants';

@Injectable()
export class OrgAuthService {
  //dataCollection: AngularFirestoreCollection<Refreshpagestatus>;
  //private firestore: Firestore = inject(Firestore);
  //private firebaseAuth: Auth   = inject(Auth);
  dataCollection: Observable<any[]>;
  aCollection;
  public user: Observable<UserOrg>;  private currentUserSubject: BehaviorSubject<UserOrg>; //public user: UserOrg;
  public currentlistReferralTypes: Observable<Referraltype[]>;  private currentListReferralTypesSubject: BehaviorSubject<Referraltype[]>;
  public currentAuthPoints: Observable<number>;  private currentAuthPointsSubject: BehaviorSubject<number>;
  //public id_token: string;
  public points:number = -10002;
  //public listReferralTypes  = [];
  constructor(
    private firestore: AngularFirestore,
    private firebaseAuth: AngularFireAuth,
    //private firebaseAuth = inject(getAuth),
    private httpClient: HttpClient, 
    private jwtHelperService: JwtHelperService, 
    private router: Router)
    //private _ngFlashService: NgFlashService) {
    {

      this.aCollection = this.firestore.collection('Refreshpagestatus');
      this.dataCollection = this.aCollection.valueChanges({ idField: 'id' });
      //this.currentUserSubject = new BehaviorSubject<UserOrg>(JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_org'))));
      //this.currentListReferralTypesSubject = new BehaviorSubject<Referraltype[]>(JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_orgref'))));
      //this.currentAuthPointsSubject = new BehaviorSubject<number>(JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_orgpts'))));

            this.currentUserSubject = new BehaviorSubject<UserOrg>(
              this.safeParse('onreference_org', null)
            );
      
            this.currentListReferralTypesSubject = new BehaviorSubject<Referraltype[]>(
              this.safeParse('onreference_orgref',[]) || []
            );
      
            this.currentAuthPointsSubject = new BehaviorSubject<number>(
              this.safeParse('onreference_orgpts',0) || 0
            );

      this.user = this.currentUserSubject.asObservable();       
      this.currentlistReferralTypes = this.currentListReferralTypesSubject.asObservable();
      this.currentAuthPoints = this.currentAuthPointsSubject.asObservable();
    }
  public get currentUserValue(): Required<UserOrg> {
      return {
        id_token: '',
        refid: '',
        refemail: '',
        refprefix: '',
        reffirstname: '',
        reflastname: '',
        refcompany: '',
        refpassword: '',
        refphone: '',
        scope: Scope.BF_ORG,
        firebasetoken: '',
        ...this.currentUserSubject.value
      };
  }
  public get getListReferralTypes(): Referraltype[] {
    return this.currentListReferralTypesSubject.value;
  }

  public get currentPoints(): number {
    return this.currentAuthPointsSubject.value;
  }

  public referralUrl = environment.gdocsurl;
  public apiUrl = environment.apiurl;
  public showLang = environment.showLang;

  public login(credentials: Credentials): Observable<any> {
      //this.user = { id: '', refemail:'',  scope: '', reffirstname: '', refprefix: '', reflastname: '', refcompany: ''  };
      this.resetSessionStorage();      
      var pwd =  CryptoJS.MD5(credentials.password) + "";      
      //var credData = JSON.parse('{"email":"'+credentials.email+'", "scope":"'+credentials.scope+'", "password":"'+pwd+'"}');
      var credData = {
        email: credentials.email?.toLowerCase().trim(),
        scope: credentials.scope,
        password: pwd
      };

      //credentials.password =  "";
      //alert('md5: '+credentials.password);
      switch (credentials.scope){
        case Scope.BF_ORG:
          var url = this.apiUrl +  'login/mainref/cred';
          const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
          return this.httpClient.post(url, credData, {headers}).pipe(
          timeout(15000), // 15 second client-side timeout
          map((response:any)   => { //console.log('Got Reponse '+JSON.stringify(response));
                //console.log('id_token value:', response.id_token);  // <-- add this
                //console.log('id_token type:', typeof response.id_token);
                const data = response;                 
                if (data?.id_token){
                    //var user1 = { id_token:'',id: '', refemail:'',  scope: '', reffirstname: '', refprefix: '', reflastname: '', refcompany: '' , firebasetoken:'' };
                    var user1: UserOrg = {} as UserOrg;   
                    user1.id_token = data.id_token;
                    user1.refemail = data.email?.toLowerCase().trim() ?? '';
                    user1.refprefix = data.prefix ?? '';
                    user1.reffirstname = data.firstname ?? '';
                    user1.reflastname = data.lastname ?? '';
                    user1.scope = Scope.BF_ORG as Scope;
                    user1.refid = data.refid ?? '';
                    user1.refcompany = data.refcompany ?? '';
                    user1.firebasetoken = data.firebasetoken ?? '';
                    const scope = user1.scope as Scope;
                    switch (scope){
                      case Scope.BF_ORG:
                          //console.log('Setting onreference_org');        
                          //console.log('About to store user1:', JSON.stringify(user1));
                          //console.log('id_token present:', user1?.id_token ? 'YES' : 'NO');
                          sessionStorage.setItem('onreference_org', this.b64EncodeUnicode(JSON.stringify(user1)));
                          break;
                      default:
                        console.log('In Scope default:'+user1.scope);
                        this.logout;
                    }
                    this.currentUserSubject.next(user1);
                    var tmplistref = this.setListReferralTypes(false);
                    var userfirebase = this.firebaselogin(user1.firebasetoken!)
                      //.then(cred => {//console.log("fb logged in: "+user1.id_token)})
                      .catch(err => { console.log("Firebase login failed: ", err); });
                    var tmpset = this.setConstantListReferralTypes();
                    //signInWithCustomToken(this.firebaseAuth, user1.firebasetoken);
                    //console.log("auth result:",this.firebaseAuth.user.toPromise.toString)
                    return {"success":true, "message": "", "response":response};
                  }else{
                    if (response.refvalidated !== 'validated' ){
                      //this._flashMessagesService.show('User is not activated. Please check your email for activation email or click on Reset Your Password', { cssClass: 'alert-success', timeout: 10000 });//alert('User is not activated. Please check your email for activation email or click on Reset Your Password');                        
                      //this._ngFlashService.success('User is not activated. Please check your email for activation email or click on Reset Your Password');
                      console.log("User is not activated. Please check your email for activation email or click on Reset Your Password.");
                      return {"success":false, "message": "User is not activated. Please go to <a href='https://dev.onreference.com/us/ind-forgot-password'>Reset your password</a> and click on the email link that is received.", "response":response};
                    }else{
                      //{"err": true,"wait": 52}
                      const wait = response.wait ?? response.result?.wait ?? 0;
                      if (wait > 0) {
                        console.log('Please wait for '+wait+' seconds');
                      }
                    //return false;
                    return {"success":false, "message": wait > 0 ? "Please wait for "+wait+" seconds" : "Login temporarily unavailable. Please try again.", "response":response};
                    }
                  }
                //}else{
                //  return false;
                //}
            }),
            //catchError((err:any, caught: Observable<any>) => ErrorObservable.create((err) ? (err) : 'Server error: '+JSON.stringify(err)) ),);
            //catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+JSON.stringify(err)) ),);
            catchError((err: any, caught: Observable<any>) => {
              if (err instanceof TimeoutError) {
                return throwError(() => ({ message: 'Request timed out. Please try again.' }));
              }
              if (err?.status === 504) {
                return throwError(() => ({ message: 'Server is temporarily unavailable (504). Please try again shortly.' }));
              }
              return throwError(() => err ?? 'Server error');
            }),
        );
      }
      return throwError(() => new Error('Unsupported login scope'));
  };

  async firebaselogin(firebasetoken: string){
    const currentFirebaseUser = await this.firebaseAuth.currentUser;
    if (currentFirebaseUser) {
      return currentFirebaseUser;
    }
    if (!firebasetoken || firebasetoken.split('.').length !== 3) {
      throw new Error('Missing or invalid Firebase custom token');
    }
    return await this.firebaseAuth.signInWithCustomToken(firebasetoken);
  }
  
  /*async firebaselogout(){
    return await this.firebaseAuth.signOut();
  }*/

  /*async firebaseDeleteToken(){
    console.log('Deleting: '+this.currentUserValue.id_token);
    return await this.firestore.collection(FS_REFRESHSTATUS).doc(this.currentUserValue.id_token).delete();
  }*/

public loggedIn() {
    return this.authenticated();
};


public authenticated() {//alert('In authenticated')
   try{

      //var user = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_org')));
      var user = this.safeParse('onreference_org',null);
      if (!this.jwtHelperService.isTokenExpired(user.id_token,15)){
        var decode = this.jwtHelperService.decodeToken(user.id_token); //alert('jwt Decode:'+JSON.stringify(decode));
        const scope = String(decode.scope) as Scope;
        switch (scope){
          case Scope.BF_ORG:
              //this.user = { id_token:'', id: '',  refemail:'', refprefix: '', scope: '', reffirstname: '',  reflastname: '' , refcompany: ''};            
              this.currentUserSubject.next(user);
              return true && this.currentUserValue;
          default:
            this.logout;
            return false;
        }        
      }
   }catch(e){//alert('logout: '+JSON.stringify(e))
        this.logout;
        return false;     
   }
   return false;
};

 

public logout() {//alert('logout')
    //Delete the token data on cloud 
    this.aCollection.doc(this.currentUserValue.id_token).delete().then(  ret => console.log("Deleted refresh token") ).catch(e => console.log("Error deleting refresh token: ",e));   

    /*var tmpdoc = this.firestore.collection(FS_REFRESHSTATUS).doc(this.currentUserValue.id_token);
    if (tmpdoc){
      tmpdoc.delete();
    }*/
    this.firebaseAuth.signOut().catch(e => console.log("Firebase sign out failed: ", e));
    this.resetSessionStorage();
    var user:UserOrg = {}; 
    this.currentUserSubject.next(user);
    this.currentListReferralTypesSubject.next([]);
    this.currentAuthPointsSubject.next(0);
    this.router.navigate(["/org-login"]);
};

private resetSessionStorage(){
 // Remove token from sessionStorage
    try{
          sessionStorage.removeItem('onreference_org');
          sessionStorage.removeItem('onreference_orgref');          

          sessionStorage.removeItem('onreference_ent');
          sessionStorage.removeItem('onreference_entref');          

          sessionStorage.removeItem('onreference_adm');

          sessionStorage.removeItem('onreference_entpts');
          sessionStorage.removeItem('onreference_orgpts'); 
          
          sessionStorage.removeItem('onreference_reuse_ind-home');
          sessionStorage.removeItem('onreference_reuse_org-home');          

    }catch(e) {
    }
}

/*private setSessionStorage(data){
    if (this.isSessionStorageNameSupported() === false){
      //this._flashMessagesService.show('Please disable "Private Mode", or upgrade to a modern browser.', { cssClass: 'alert-success', timeout: 10000 });//alert('Please disable "Private Mode", or upgrade to a modern browser.');
      this._ngFlashService.success('Please disable "Private Mode", or upgrade to a modern browser.');
      return false; 
    }
    //this.id_token = data.id_token;
    //this.user.id = data.id;
    this.user.id_token = data.id_token;
    this.user.refprefix = (data.refprefix !== undefined) ? data.refprefix : "" ;    
    this.user.reffirstname = (data.reffirstname !== undefined) ? data.reffirstname : "" ;
    this.user.reflastname = (data.reffirstname !== undefined) ? data.reflastname : "" ;
    this.user.refcompany = (data.refcompany !== undefined) ? data.refcompany : "" ;
    //this.user.scope = data.scope; 
    //alert("Data scope: "+data.scope+" Scope.BF_ORG: "+Scope.BF_ORG);
    try{
      switch (parseInt(data.scope)){
        case Scope.BF_ORG:
          try{

              sessionStorage.setItem('onreference_org', this.b64EncodeUnicode(JSON.stringify(this.user)));
              return true;
          }catch(e) {
            //this._flashMessagesService.show('Cannot set session: Please use modern browser or disable private mode.', { cssClass: 'alert-success', timeout: 10000 });//alert('Cannot set session: Please use modern browser or disable private mode.');
            this._ngFlashService.success('Cannot set session: Please use modern browser or disable private mode.');
          }
        default:
          this.logout;
          return false;
      }      
    }catch(e){
      if (this.isSessionStorageNameSupported() === false){
        //this._flashMessagesService.show('Please disable "Private Mode", or upgrade to a modern browser.', { cssClass: 'alert-success', timeout: 10000 });//alert('Please disable "Private Mode", or upgrade to a modern browser.');
        this._ngFlashService.success('Please disable "Private Mode", or upgrade to a modern browser.');
        return false; 
      }else{
        //this._flashMessagesService.show('Error: Please close tab and login again.', { cssClass: 'alert-success', timeout: 10000 });//alert('Please disable "Private Mode", or upgrade to a modern browser.');        
        this._ngFlashService.success('Error: Please close tab and login again.');
        return false;
      }

    }
}*/

public setConstantListReferralTypes(){
  /*var tmp:Referraltype[] = [];
  //let tmp: any[] = [];
  for (var i in MAINREFREFERENCEMASTER_REFID){
    tmp.push(MAINREFREFERENCEMASTER_REFID[i]);
  }*/
  //console.log("Setting onreference_orgref: ",MAINREFREFERENCEMASTER_REFID);
  sessionStorage.setItem('onreference_orgref', this.b64EncodeUnicode(JSON.stringify(MAINREFREFERENCEMASTER_REFID)));
  this.currentListReferralTypesSubject.next(MAINREFREFERENCEMASTER_REFID);
  sessionStorage.setItem('onreference_orgpts', this.b64EncodeUnicode(JSON.stringify(this.points)));
  this.currentAuthPointsSubject.next(this.points);
  return true;
}
public setListReferralTypes(force){
   try{
      var tmplist = this.setConstantListReferralTypes();
      var tmplistReferralTypes:Referraltype[] = [];
      //var user = (this.user != undefined) ? this.user : this.b64DecodeUnicode(sessionStorage.getItem('onreference_org'));
      var user = this.currentUserValue;
      var decode = this.jwtHelperService.decodeToken(user.id_token); 
      const scope = String(decode.scope) as Scope;;
      switch (scope){
        case Scope.BF_ORG:
          if (!this.jwtHelperService.isTokenExpired(user.id_token,15)){
              return this.getSetReferralTypes(user.id_token, scope).pipe(first()).subscribe((data:any) => {
                  //console.log('in getreferaltypes subscribe'+JSON.stringify(data));
                  //var obj = data; //JSON.parse(JSON.stringify(data));
                  var res200 = (data.status == "200") ? true: (data.errorcode);
                  if (res200 === true){
                    //this.listReferralTypes = [];
                    for (var i in data.result){//alert('objresult: '+data.result[i].referenceid);
                      if (i == "mainrefpoints"){
                        try{
                            sessionStorage.setItem('onreference_orgpts', this.b64EncodeUnicode(JSON.stringify(parseInt(data.result[i]))));
                            this.points = parseInt(data.result[i]);//console.log('Data.result: ', data.result[i]);
                            this.currentAuthPointsSubject.next(this.points);
                        }catch(e) {
                          //this._flashMessagesService.show('Cannot set session: Please use modern browser or disable private mode.', { cssClass: 'alert-success', timeout: 10000 });//alert('Cannot set session: Please use modern browser or disable private mode.');
                          //this._ngFlashService.success('Cannot set session: Please use modern browser or disable private mode.');
                        }
                      }else{
                        //this.listReferralTypes.push(data.result[i]);
                        tmplistReferralTypes.push(data.result[i]);
                      }
                    }
                    try{
                        //console.log('setting onreference_orgref full: ',tmplistReferralTypes);
                        sessionStorage.setItem('onreference_orgref', this.b64EncodeUnicode(JSON.stringify(tmplistReferralTypes)));
                        /*var tmp1:Referraltype[] = [];
                        for (var i in tmplistReferralTypes){
                          tmp1.push(tmplistReferralTypes[i]);
                        }*/
                        this.currentListReferralTypesSubject.next(tmplistReferralTypes);
                        //console.log('DOne with currentListReferralTypes: ',tmplistReferralTypes);
                    }catch(e) {
                      //this._flashMessagesService.show('Could not set reference types. Please logout and login.', { cssClass: 'alert-success', timeout: 10000 });//alert('Could not set reference types. Please logout and login.');
                      //this._ngFlashService.success('Could not set reference types. Please logout and login.');
                      this.logout;
                      return false;
                    }
                    return true;
                  }else{
                    //this._flashMessagesService.show('Error in getReferencemaster-'+JSON.stringify(res200), { cssClass: 'alert-success', timeout: 10000 });//alert('Error in getReferencemaster-'+JSON.stringify(res200));
                  }
                  this.logout;
                  return false;
                });
          }
        default:
          this.logout;
          return false;
      }
   }catch(e){
        this.logout;
        return false;     
   }

}
private getSetReferralTypes(id_token,scope){
        //var body = '{ "id_token":"'+this.id_token+'", "ops":"4", "scope":"3" , "entid":"'+this.user.id+'" }';
        //var body = '{ "id_token":"'+id_token+'", "ops":"'+Ops.GETREFERRALTYPES+'", "scope":"'+decode.scope+'" , "entid":"'+decode.id+'" }';
        //var body = '{ "id_token":"'+id_token+'", "ops":"'+Ops.GETREFERRALTYPES+'" ,  "scope":"'+parseInt(decode.scope)+'" }';        
        var body = {id_token:'', ops: '',  scope: ''};
        body.id_token = (id_token !== undefined) ? id_token : "";
        body.ops = (Ops.GETREFERRALTYPES.toString() !== undefined) ? Ops.GETREFERRALTYPES.toString() : "";
        body.scope = (scope !== undefined) ? scope : "";
        //console.log('Before getSetReferralTypesOrg post Body:'+JSON.stringify(body));
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.httpClient.post(this.referralUrl, body, {headers}).pipe(
        //retry(3),          
        map((res:any) => {//console.log('Got referraltypes map:'+JSON.stringify(res));
          return res;//return res.json();
        }),
        catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),)
}

/*public getListReferralTypes(){
  //return  (this.listReferralTypes != undefined && this.listReferralTypes.length > 0) ? this.listReferralTypes : this.setListReferralTypes(false) ;
  if  (this.listReferralTypes != undefined && this.listReferralTypes.length > 0) {
    return this.listReferralTypes;
  }
  
  try{               
    this.listReferralTypes = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_orgref')));
  }catch(e) {      
    this.setListReferralTypes(false);
    this.listReferralTypes = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_orgref')));
  }                              

  return this.listReferralTypes;  
}*/

public getPoints(force){
  if (force){
    this.setListReferralTypes(true);
  }else{
    if  (this.currentPoints != undefined && this.currentPoints != -10002) {
      return this.currentPoints;
    }else{
      return 0;
    }
  }
  return this.currentPoints;

  /*try{        
    this.points = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_orgpts')));         
  }catch(e) {      
    this.setListReferralTypes(false);
    this.points = JSON.parse(this.b64DecodeUnicode(sessionStorage.getItem('onreference_orgpts')));
    //this._flashMessagesService.show('Refreshing points.', { cssClass: 'alert-success', timeout: 10000 });//alert('Cannot set session: Please use modern browser or disable private mode.');
  }
  return this.points;                */

}

public updatePoints(points){
  
  try{                                
    sessionStorage.setItem('onreference_orgpts', this.b64EncodeUnicode(JSON.stringify(points)));
    this.currentAuthPointsSubject.next(points);
  }catch(e) {
    //this._flashMessagesService.show('Cannot set session: Please use modern browser or disable private mode.', { cssClass: 'alert-success', timeout: 10000 });//alert('Cannot set session: Please use modern browser or disable private mode.');
   // this._ngFlashService.success('Cannot set session: Please use modern browser or disable private mode.');
  }                              
}

p/*rivate isSessionStorageNameSupported() { 
    var testKey = 'test';
    try {
      sessionStorage.setItem(testKey, '1');
      sessionStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }*/

  private b64EncodeUnicode(str) {
    try{
     var words = CryptoJS.enc.Utf8.parse(str);
     return CryptoJS.enc.Base64.stringify(words)
    }catch (e){
      return "";
    }
    /*return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
   }))*/
  }

   /*public b64DecodeUnicode(base64) {
     if (base64 === null){ return null};
     try{
      var words = CryptoJS.enc.Base64.parse(base64);
      return CryptoJS.enc.Utf8.stringify(words);  
     }catch(e){
      return "";
     }
    //return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
    //    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    //}).join(''));
   }*/

    public b64DecodeUnicode(base64) {
       try {
         if (!base64) return null;
         const words = CryptoJS.enc.Base64.parse(base64);
         return CryptoJS.enc.Utf8.stringify(words);
       } catch (e) {
         console.error('Base64 decode failed:', e);
         return null;
       }
     }
   

   private getHeaderOptions(id_token){
    // //let headers = new Headers();
     //headers.append('Content-Type', 'text/plain');
     //headers.append('Authorization', id_token);
     //headers.append('Access-Control-Allow-Origin', 'https://script.googleusercontent.com');
     //headers.append('Access-Control-Allow-Origin', '*');
   // //return new RequestOptions({ headers: headers });
    if (id_token){
         var httpOptions = {
           headers: new HttpHeaders({
             'Content-Type':  'application/json',
             //'Content-Type':  'text/plain',
             Authorization: id_token
           })
         };
       }else{
         var httpOptions = {
           headers: new HttpHeaders({
             'Content-Type':  'application/json',
             //'Content-Type':  'text/plain',
             //Authorization: id_token
           })
         };
       }
         return httpOptions;
  }

        private safeParse(key: string, fallback: any) {
        try {
          const raw = sessionStorage.getItem(key);
          if (!raw) return fallback;

          const decoded = this.b64DecodeUnicode(raw);
          if (!decoded) return fallback;

          return JSON.parse(decoded);
        } catch (e) {
          console.error(`Error parsing ${key}:`, e);
          return fallback;
        }
      }

}
